import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[view-container]',
})
export class M4UViewContainerDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}